module.exports = __webpack_public_path__ + "media/unsuccess.be595240.mp3";